import React, { type FunctionComponent } from 'react'
import { locationHasInvalidCoordinates } from '../locationHelpers'

type Props = {
  ariaLabel: string
  locations: ExternalLocationType[]
  selectedLocation?: ExternalLocationType
  onLocationClicked: (location: ExternalLocationType) => void
}

export const ExternalLocationsList: FunctionComponent<Props> = ({
  ariaLabel,
  locations,
  selectedLocation,
  onLocationClicked
}) => {
  const locationIsSelected = (location: ExternalLocationType) => selectedLocation?.externalId === location.externalId

  return (
    <ul aria-label={ariaLabel}>
      {locations.map((location: ExternalLocationType) => (
        <li key={location.externalId} className="relative odd:bg-gray-100">
          <button
            aria-label={location.name}
            className={
              locationIsSelected(location)
                ? 'p-4 text-left w-full outline-none bg-gray-200'
                : 'p-4 text-left w-full outline-none focus:ring-4 focus:ring-gray-500 focus:ring-opacity-50'
            }
            onClick={() => onLocationClicked(location)}
          >
            <div className="flex space-x-4 items-center">
              <div className="flex-1">
                <div className="font-bold mb-1">{location.name}</div>
                <div className="text-sm">
                  {location.address}, {location.city} {location.state}, {location.zipCode}
                </div>
              </div>

              {location?.oldValue ? (
                <span className="icon-[fluent--arrow-right-24-regular] size-4" />
              ) : location.lastUpdated ? (
                <div className="text-sm">{new Date(location.lastUpdated).toLocaleDateString()}</div>
              ) : location.created ? (
                <div className="text-sm">{new Date(location.created).toLocaleDateString()}</div>
              ) : null}

              {locationHasInvalidCoordinates(location) && (
                <div className="mt-1 group">
                  <span className="absolute top-0 right-2 py-2 px-4 text-white rounded-lg bg-[rgba(0,0,0,0.8)] transform translate-y-[20%] transition opacity-0 pointer-events-none group-hover:opacity-100 group-hover:translate-y-[0]">
                    {location.name} has invalid or missing coordinates and will not be shown on the map
                  </span>
                  <span className="icon-[fluent--location-24-regular] size-6 text-rose-500" />
                </div>
              )}
            </div>
          </button>
        </li>
      ))}
    </ul>
  )
}
